import { ValueType } from '../data-conversion';
import { ElementData } from '../device';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class TableSensorListWidget {
  id!: string;
  name?: string;
  type?: string;
  virtual?: boolean;
  cron?: boolean;
  lastActiveNanos?: number;
  booleanType?: boolean;
  metadata?: { [key: string]: string };
  deviceData?: ElementData;
  unit?: string;
  valueType?: ValueType;
  sensorPrecision?: number;
}
/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class SensorsListCSVHeaders {
  Sensor_Name?: string;
  Sensor_value?: number | string;
  Sensor_Unit?: number | string;
  Subsystem?: string;
  Timeframe?: string;
  'Sortable Timeframe (Unix Timestamp ms)': number | string;
}
